import { type FC } from 'react'
import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import PredictiveAIModelsImage from './PredictiveAIModelsImage'

const copy = {
  heading: `Elevate every customer interaction with user-friendly predictive AI`,
  description: `CustomerAI Predictions gives marketers easy-to-use, out-of-the-box predictive models built on trusted, AI-ready data in Segment to quickly create Predictive Traits that get added to the customer profile to power more timely, targeted, and precisely personalized customer experiences on every channel.`,
  list: [
    {
      title: `Likelihood to Purchase`,
      description: `Predict the propensity of customers to make a purchase.`,
    },
    {
      title: `Likelihood to Churn`,
      description: `Proactively identify customers who are likely to stop using your product.`,
    },
    {
      title: `Predicted Lifetime Value (LTV)`,
      description: `Predict a customer's future spend over the next 90 days.`,
    },
    {
      title: `Custom Predictive Goals`,
      description: `Predict the propensity of customers to perform any event tracked in Segment (e.g. likelihood to use a promo code or refer a friend).`,
    },
  ],
}

const PredictiveAIModels: FC = () => {
  return (
    <>
      <SectionBase variant="centered">
        <StyledCopyTextBase centered={true}>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description tag="p" variant="pLarge">
            {copy.description}
          </CopyText.Description>
        </StyledCopyTextBase>
      </SectionBase>
      <SectionBase variant="2Col">
        <Section.Copy>
          <ColumnTrack>
            {copy.list.map(({ title, description }, key) => (
              <CopyTextBase key={key}>
                <CopyText.Heading tag="h3" variant="h5">
                  {title}
                </CopyText.Heading>
                <CopyText.Description tag="p">{description}</CopyText.Description>
              </CopyTextBase>
            ))}
          </ColumnTrack>
        </Section.Copy>
        <Section.Contents>
          <PredictiveAIModelsImage />
        </Section.Contents>
      </SectionBase>
    </>
  )
}

const StyledCopyTextBase = styled(CopyTextBase)`
  max-width: 844px;
`

export default PredictiveAIModels
